import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface EmptyAppointmentsProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyAppointments({
  title = 'Nenhum agendamento encontrado',
  description = 'Você ainda não tem agendamentos. Que tal marcar sua primeira consulta?',
  actionLabel = 'Marcar consulta',
  onAction,
}: EmptyAppointmentsProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-16 h-16 mb-4 rounded-full bg-muted flex items-center justify-center">
        <Calendar className="w-8 h-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-muted-foreground mb-6 max-w-sm">{description}</p>
      {onAction && (
        <Button onClick={onAction}>{actionLabel}</Button>
      )}
    </div>
  );
}
